import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AddNewAccountService } from '../../core/services/addNewAcccount/add-new-account.service';
import {
  addNewAccountFailed,
  addNewAccountReceived,
  addNewAccountRequest,
} from '../actions/addNewAccount';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
@Injectable()
export class addNewAccountEffect {
  constructor(
    private actions: Actions,
    private addNewAccountService: AddNewAccountService,
    private snackbarService: SnackbarService,
  ) {}

  addNewAccountRequest$ = createEffect(() =>
    this.actions.pipe(
      ofType(addNewAccountRequest),
      mergeMap((action) =>
        this.addNewAccountService.addnewAccount(action.params).pipe(
          map((data) => {
            return addNewAccountReceived({ params: data });
          }),
          catchError((error) => {
            this.snackbarService.handleError(error);
            return of(addNewAccountFailed(error));
          }),
        ),
      ),
    ),
  );
}
